<div class="modal-body">
  <company-searcher
    class="d-block mb-3 pb-2"
    *ngIf="!company"
    [compact]="true"
    [bakeryId]="bakeryId"
    [countryCode]="countryCode"
    [allowEhk]="true"
    (onCompanyFound)="continueWithCompany($event)"
  ></company-searcher>

  <div class="form-group"
       *ngIf="company">
    <label class="font-md fw-bold">{{'common.companyName' | translate}}</label>

    <div class="org-name-org-number">
      <input class="form-control"
             [disabled]="true"
             [value]="company.legalCompany.name">

      <div class="invoice-info-org-number font-md">
        {{company.legalCompany.orgNumber}}
      </div>
    </div>

    <div class="text-end">
      <span class="pointer hover-underline font-md"
            [translate]="'orderProcess.payment.userInvoiceInfo.changeCompany'"
            (click)="changeCompany()">
        Change company
      </span>
    </div>
  </div>

  <form [formGroup]="userForm" *ngIf="company" novalidate>
    <div class="form-group">
      <label class="font-md fw-bold">{{'common.fullName' | translate}}</label>
      <input class="form-control"
             [placeholder]="'common.fullName' | translate"
             [maxlength]="'32'"
             [formControlName]="'fullName'">
    </div>

    <div class="form-group">
      <label class="font-md fw-bold">{{'common.emailAddress' | translate}}</label>
      <input class="form-control"
             [placeholder]="'common.email' | translate"
             [maxlength]="'128'"
             [formControlName]="'email'">
    </div>

    <div class="form-group">
      <label class="font-md fw-bold">{{'common.password' | translate}}</label>
      <div class="register-password-wrap">
        <input class="form-control"
               autocomplete="new-password"
               [type]="showPassword ? 'text' : 'password'"
               [placeholder]="'common.password' | translate"
               [maxlength]="'32'"
               [formControlName]="'password'">

        <i class="password-eye icon-view"
           *ngIf="!showPassword"
           (click)="showPassword=!showPassword"></i>
        <i class="password-eye icon-unpublish"
           *ngIf="showPassword"
           (click)="showPassword=!showPassword"></i>
      </div>
    </div>

    <ui-message class="d-block mt-3 mb-3 font-md"
                *ngIf="error"
                [type]="'error'">{{error}}
    </ui-message>

    <div>
      <ui-checkbox [(model)]="subscribedOnNews">
        <span class="font-md" [innerHTML]="'auth.subscribeOnNews' | translate"></span>
      </ui-checkbox>
    </div>

    <div class="modal-auth-controls mb-3 text-end">
      <button class="btn btn-pink font-lg"
              [disabled]="userForm.invalid"
              (click)="submit()">{{'auth.createAccount' | translate}}
      </button>
    </div>
  </form>


</div>
